import type { AttributeEditModeConfig } from '@source-components-react/types';
import {
  DEFAULT_LIST_KIND,
  LIST_INLINE_STYLES_ATTRIBUTE,
  LIST_ITEMS_ATTRIBUTE,
  LIST_KIND_ATTRIBUTE,
  LIST_LINKS_ATTRIBUTE,
  LIST_MARKER_ATTRIBUTE,
  LIST_REVERSED_ATTRIBUTE,
  LIST_START_ATTRIBUTE,
} from './list-attributes';

/**
 * Every setting the list offers, in the order the Modify drawer shows them.
 *
 * Order is not cosmetic. The drawer renders these top to bottom and the
 * documentation registry asserts its pages match that sequence, so moving an
 * entry here moves it in both places at once.
 */
export const attributeEditModeConfigs: AttributeEditModeConfig[] = [
  {
    name: LIST_ITEMS_ATTRIBUTE,
    heading: 'List Items',
    subHeading:
      'The items, one per line — each line becomes its own entry in the list. Blank lines are skipped, for 3 different device resolutions',
    defaultValues: {},
  },
  {
    name: LIST_KIND_ATTRIBUTE,
    heading: 'List Kind',
    subHeading:
      'Bulleted (unordered) or numbered (ordered). Numbered lists can also set where counting starts and whether it counts down, for 3 different device resolutions',
    defaultValues: { all: DEFAULT_LIST_KIND },
  },
  {
    name: LIST_MARKER_ATTRIBUTE,
    heading: 'Marker Style',
    subHeading:
      'What sits in front of each item: a disc, circle or square for bullets; numbers, letters or Roman numerals for numbering; or none to hide the markers. Unset uses the browser default for the list kind, for 3 different device resolutions',
    defaultValues: {},
  },
  {
    name: LIST_START_ATTRIBUTE,
    heading: 'Numbering Start',
    subHeading:
      'The number the first item counts from. Only a numbered list reads this; leave unset to count from 1, for 3 different device resolutions',
    defaultValues: {},
  },
  {
    name: LIST_REVERSED_ATTRIBUTE,
    heading: 'Reversed Numbering',
    subHeading:
      'Whether a numbered list counts down instead of up, e.g. a top-10 countdown. Only a numbered list reads this, for 3 different device resolutions',
    defaultValues: {},
  },
  {
    name: LIST_LINKS_ATTRIBUTE,
    heading: 'Links',
    subHeading:
      'Links the items can point at. To link part of an item, wrap those words in {1|linked text}, where the number is the position of the entry in this list counting from 1; clearing an entry leaves its position in place so the other numbers keep pointing where they did, for 3 different device resolutions',
    defaultValues: {},
  },
  {
    name: LIST_INLINE_STYLES_ATTRIBUTE,
    heading: 'Class Names & Styles',
    subHeading:
      'Class names and CSS the items can apply to part of themselves, e.g. to give a few words their own colour. To apply an entry, wrap those words in {.1|styled text}, where the number is the position of the entry in this list counting from 1; clearing an entry leaves its position in place so the other numbers keep pointing where they did, for 3 different device resolutions',
    defaultValues: {},
  },
];
